// extracted by mini-css-extract-plugin
export var component = "post-image-module--component--3lUiq";
export var link = "post-image-module--link--37Nuu";